<template>
  <div class="spacer"></div>
</template>

<script>
export default {}
</script>

<style>
.spacer {
  height: 2rem;
}
</style>
